// The following code is pulled from and inspired by the `bonFHIR` implementation
// https://bonfhir.dev/packages/core/fhir-client#mergers
// https://github.com/bonfhir/bonfhir/blob/1e929e2c67734a813ad62ab0e79606cb1f7652a8/packages/core/src/r4b/mergers/default-merger.ts

import type { Merger } from '#src/merge/mergers/merger.ts'

/** The default strategy for merge, that merges values one-by-one. */
export const defaultMerger: Merger = {
  canMerge: () => true,
  merge: ({ current, incoming }, merge) => {
    if (current === undefined || current === null) {
      return incoming
    }
    if (incoming === undefined || incoming === null) {
      return current
    }
    if (typeof incoming === 'object' && typeof current === 'object') {
      const merged = current
      for (const [key, value] of Object.entries(incoming)) {
        merged[key] = merge({
          current: merged[key],
          incoming: value,
          key,
        })
      }
      return merged
    }

    return incoming
  },
}
